import type { ComponentProps } from 'react';
import { useRef } from 'react';

import { cn, useIsClamped } from '@crm/shared/lib';

import { getDealInfoText } from '../../lib';
import { DEFAULT_OBJECT_VALUE } from '../../model/config';
import { DealTableCell } from '../DealTableCell';

import type { TDeal } from '../../model/deal';

type DealObjectCellProps = Pick<ComponentProps<typeof DealTableCell>, 'className'> & {
    area?: TDeal['area'];
    maxLines?: 1 | 2;
    objectName?: string | null;
    objectType?: TDeal['objectType'];
    unit?: TDeal['unit'];
};

export const DealObjectCell = ({
    area,
    className,
    maxLines = 1,
    objectName,
    objectType,
    unit,
}: DealObjectCellProps) => {
    const textRef = useRef<HTMLParagraphElement>(null);
    const isClamped = useIsClamped(textRef);
    const dealInfoText =
        objectName !== undefined
            ? (objectName ?? '')
            : getDealInfoText({ objectType, area, unit, joinSeparator: ' | ' });

    const textContent = dealInfoText.length > 0 ? dealInfoText : DEFAULT_OBJECT_VALUE;

    return (
        <DealTableCell
            isEmpty={!textContent}
            title={isClamped ? textContent : undefined}
            className={cn('px-1', className)}
        >
            <p
                ref={textRef}
                className={cn(maxLines === 2 ? 'line-clamp-2 leading-4 whitespace-normal' : 'truncate')}
            >
                {textContent}
            </p>
        </DealTableCell>
    );
};
